import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e1cf59c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#F0F2F5","height":"100vh"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { style: {"display":"flex","flex-direction":"column","align-items":"end","margin-right":"2em"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  style: {"padding-left":"2em","padding-right":"2em","padding-top":"5em","width":"100%","height":"95vh","position":"fixed","background-color":"#F0F2F5"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "An application has already been submitted.", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  style: {"padding-left":"2em","padding-right":"2em","padding-top":"5em","width":"100%","height":"95vh","position":"fixed","background-color":"#F0F2F5"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Thank you for your submission.", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { style: {"display":"flex","justify-content":"center","padding-left":"2em","padding-right":"2em","padding-top":"5em","width":"100%","height":"95vh","position":"fixed","background-color":"#F0F2F5"} }
const _hoisted_15 = { style: {"max-width":"40em"} }
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { style: {"text-align":"left","max-width":"60em","margin-left":"2em","margin-right":"2em"} }
const _hoisted_19 = ["src"]
const _hoisted_20 = { style: {"display":"flex","flex-direction":"column","flex-wrap":"wrap","flex-grow":"1","margin-bottom":"2em"} }
const _hoisted_21 = {
  class: "expandableContent",
  style: {"margin-top":"-2em"}
}
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { style: {"margin":"3em 0 0"} }
const _hoisted_24 = { style: {"margin-bottom":"2em","margin-top":"3em"} }
const _hoisted_25 = { style: {"margin-bottom":"0em"} }
const _hoisted_26 = { style: {"width":"fit-content","display":"flex","margin-top":"2em"} }
const _hoisted_27 = { class: "p-float-label pr-8" }
const _hoisted_28 = { for: "educationDropdown" }
const _hoisted_29 = {
  key: 0,
  style: {"margin-bottom":"2em","margin-top":"3em"}
}
const _hoisted_30 = ["for"]
const _hoisted_31 = { style: {"margin-top":"4em"} }
const _hoisted_32 = {
  class: "field-checkbox mt-4",
  style: {"width":"fit-content","display":"flex"}
}
const _hoisted_33 = { for: "wantsJobOffers" }
const _hoisted_34 = { class: "pt-5" }
const _hoisted_35 = { class: "pt-5" }
const _hoisted_36 = {
  class: "field-checkbox mt-6",
  style: {"width":"fit-content","display":"flex"}
}
const _hoisted_37 = { for: "acceptPrivacyPolicy" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "pt-5 pb-8" }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { style: {"text-align":"left","max-width":"60em","margin-left":"2em","margin-right":"2em"} }
const _hoisted_42 = ["src"]
const _hoisted_43 = { style: {"display":"flex","flex-direction":"column","flex-wrap":"wrap","flex-grow":"1","margin-bottom":"2em"} }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "This position is no longer available.", -1))

import AttachmentsView from "@/components/AttachmentsView.vue";
import {sendApplication,  applicationText,  education, wantsJobOffers} from "@/model/store";
import {useToast} from "primevue/usetoast";
import {onMounted, ref} from "vue";
import {JobApplication, JobListing, User} from "@/types/shared";
import {getJobListing} from "@/model/api-no-auth";
import ExpandableBaseballCard from "@/components/ExpandableBaseballCard.vue";
import {language, locStr} from "@/model/localizations";
import {signOut} from "@/model/firebase";
import {getCurrentUser, getUserApplications} from "@/model/api";
import {currentUserEmail} from "@/model/store";

interface Answer {
  text: string
  id: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
  listingId: {
    required: true,
    type: String
  },
},
  setup(__props) {

const props = __props

const toast = useToast()

const profilingCompleted = ref(false)
const surveyAccessToken = ref('')

const jobListing = ref<JobListing|undefined>()
const existingApplication = ref<JobApplication|undefined>()

const currentUser = ref<User|undefined>()

const answers = ref(Array<Answer>())
const didAcceptPrivacyPolicy = ref(false)



const onSendApplication = async () => {
  const answerIds = answers.value.map(a => a.id)
  const response = await sendApplication(props.listingId, answerIds)
  if (response?.errorMessage) {
    toast.add({severity: 'error', summary: 'Info mangler', detail: `${response.errorMessage}`, life: 10000})
  } else if (response?.profileCompleted) {
    profilingCompleted.value = true
  } else if (response?.accessToken) {
    surveyAccessToken.value = response.accessToken
  }
}

onMounted(async () => {
  currentUser.value = await getCurrentUser()
  const listing = await getJobListing(props.listingId)
  jobListing.value = listing
  if (listing && listing.language) language.value = listing.language
  // language.value = 'no'
  const applications = await getUserApplications(props.listingId)
  if (applications?.length) {
    existingApplication.value = applications[0]
  }
})


return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toast),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(currentUserEmail))
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
            _createTextVNode("Signed in as " + _toDisplayString(_unref(currentUserEmail)) + " - ", 1),
            _createElementVNode("b", {
              style: {"cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(signOut) && _unref(signOut)(...args)))
            }, "Sign out")
          ]))
        : _createCommentVNode("", true)
    ]),
    (existingApplication.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          (currentUser.value?.survey?.accessToken && !currentUser.value?.survey?.answersSubmitted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("a", {
                  class: "p-button m-5 p-button-secondary",
                  style: {"text-decoration":"none"},
                  href: `https://dscor.net/survey/${currentUser.value.survey.accessToken}`
                }, "Continue to survey", 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (profilingCompleted.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
        : (jobListing.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (surveyAccessToken.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("h2", null, _toDisplayString(_unref(locStr).jobApplication.completedPartOneHeading), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", null, _toDisplayString(_unref(locStr).jobApplication.thankYouPrefix) + _toDisplayString(jobListing.value.employerName) + ".", 1),
                          _createElementVNode("p", null, _toDisplayString(_unref(locStr).jobApplication.nextStepDescription), 1),
                          _createElementVNode("p", null, _toDisplayString(_unref(locStr).jobApplication.startNowText), 1)
                        ]),
                        _createElementVNode("a", {
                          class: "p-button m-5 p-button-secondary",
                          style: {"text-decoration":"none"},
                          href: `https://dscor.net/survey/${surveyAccessToken.value}`
                        }, "Start survey now", 8, _hoisted_16)
                      ])
                    ])
                  ]))
                : (jobListing.value.open)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (jobListing.value.logoURL)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: jobListing.value.logoURL,
                              alt: "",
                              style: {"width":"7em","margin-top":"1.5em","margin-bottom":"0.5em"}
                            }, null, 8, _hoisted_19))
                          : _createCommentVNode("", true),
                        _createVNode(ExpandableBaseballCard, {
                          style: {"margin-top":"1em"},
                          "default-expanded": false,
                          "expand-label": _unref(locStr).jobApplication.showFullApplicationText
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("h2", null, _toDisplayString(jobListing.value.title), 1),
                              _createElementVNode("i", null, _toDisplayString(jobListing.value.employerName), 1)
                            ])
                          ]),
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", {
                                innerHTML: jobListing.value.summary
                              }, null, 8, _hoisted_22)
                            ])
                          ]),
                          _: 1
                        }, 8, ["expand-label"]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("h3", null, _toDisplayString(_unref(locStr).jobApplication.aboutHeading), 1),
                          _createElementVNode("p", null, _toDisplayString(_unref(locStr).jobApplication.aboutText), 1),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("h2", _hoisted_25, _toDisplayString(_unref(locStr).jobApplication.partOneHeading), 1)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("span", _hoisted_27, [
                              _createVNode(_component_Dropdown, {
                                id: "educationDropdown",
                                style: {"width":"18em"},
                                options: _unref(locStr).jobApplication.educationLevels,
                                modelValue: _unref(education),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(education) ? (education).value = $event : null))
                              }, null, 8, ["options", "modelValue"]),
                              _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(locStr).jobApplication.education), 1)
                            ])
                          ]),
                          (jobListing.value.checkedQuestions.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("h3", null, _toDisplayString(_unref(locStr).jobApplication.otherQualifications), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobListing.value.checkedQuestions, (question) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: question.id,
                              class: "field-checkbox",
                              style: {"width":"fit-content","display":"flex"}
                            }, [
                              _createVNode(_component_Checkbox, {
                                id: question.id,
                                name: "answers",
                                value: question,
                                modelValue: answers.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((answers).value = $event))
                              }, null, 8, ["id", "value", "modelValue"]),
                              _createElementVNode("label", {
                                for: question.id
                              }, _toDisplayString(question.text), 9, _hoisted_30)
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("h3", null, _toDisplayString(_unref(locStr).jobApplication.storeProfileHeading), 1)
                          ]),
                          _createElementVNode("p", null, _toDisplayString(_unref(locStr).jobApplication.storeProfileText), 1),
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_Checkbox, {
                              id: "wantsJobOffers",
                              name: "wantsJobOffers",
                              binary: true,
                              modelValue: _unref(wantsJobOffers),
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(wantsJobOffers) ? (wantsJobOffers).value = $event : null))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(locStr).jobApplication.storeProfileCheckbox), 1)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("h2", null, _toDisplayString(_unref(locStr).jobApplication.applicationTextHeading), 1),
                            _createVNode(_component_Textarea, {
                              modelValue: _unref(applicationText),
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(applicationText) ? (applicationText).value = $event : null)),
                              rows: "8",
                              style: {"width":"100%"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("h2", null, _toDisplayString(_unref(locStr).jobApplication.attachmentsHeading), 1),
                            _createTextVNode(" " + _toDisplayString(_unref(locStr).jobApplication.attachmentsText) + " ", 1),
                            _createVNode(AttachmentsView)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_Checkbox, {
                            id: "wantsJobOffers",
                            name: "acceptPrivacyPolicy",
                            binary: true,
                            modelValue: didAcceptPrivacyPolicy.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((didAcceptPrivacyPolicy).value = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("label", _hoisted_37, [
                            _createElementVNode("div", {
                              innerHTML: _unref(locStr).jobApplication.privacyPolicyHTML
                            }, null, 8, _hoisted_38)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_Button, {
                            label: _unref(locStr).jobApplication.continueButton,
                            disabled: !didAcceptPrivacyPolicy.value,
                            class: "p-button-secondary",
                            onClick: onSendApplication
                          }, null, 8, ["label", "disabled"])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        (jobListing.value.logoURL)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: jobListing.value.logoURL,
                              alt: "",
                              style: {"width":"7em","margin-top":"1.5em","margin-bottom":"0.5em"}
                            }, null, 8, _hoisted_42))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("h2", null, _toDisplayString(jobListing.value.title), 1),
                          _createElementVNode("i", null, _toDisplayString(jobListing.value.employerName), 1)
                        ]),
                        _hoisted_44
                      ])
                    ]))
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})